import { render, staticRenderFns } from "./productManagement.vue?vue&type=template&id=c78d0f9c&scoped=true"
import script from "./productManagement.vue?vue&type=script&lang=js"
export * from "./productManagement.vue?vue&type=script&lang=js"
import style0 from "./productManagement.vue?vue&type=style&index=0&id=c78d0f9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c78d0f9c",
  null
  
)

export default component.exports